import { StateUtils } from '@spartacus/core';
import { BonusAvailable, LoginForm, LoyaltyQrResponse } from '@user/const';

export const CUSTOM_USER_FEATURE = 'customUser';
export const BONUS_BALANCE = '[CustomUser] Bonus balance';
export const JOIN_LOYALTY_PROGRAM_ENTITY = '[CustomUser] Join loyalty program entity';
export const LOGIN = '[CustomUser] Login';
export const SUBMIT_AUTH_CODE = '[CustomUser] Submit Auth Code';
export const LOYALTY_QR = '[CustomUser] Loyalty QR';

export interface StateWithCustomUser {
  [CUSTOM_USER_FEATURE]: CustomUserState;
}

export interface CustomUserState {
  login: StateUtils.LoaderState<LoginForm>;
  submitAuthCode: StateUtils.LoaderState<string>;
  legalEntityStatus: boolean;
  bonusBalance: StateUtils.LoaderState<BonusAvailable>;
  joinLoyaltyProgram: StateUtils.LoaderState<void>;
  loyaltyQr: StateUtils.LoaderState<LoyaltyQrResponse>;
}
